<script>
import * as echarts from 'echarts';
import api from "@/api";
import {mapGetters} from "vuex";

export default {
  name: 'OrderChart',
  data() {
    return {
      queryForm: {
        groupId: 'supplier_name',
        day: 7
      }
    }
  },
  computed: {
    ...mapGetters(
      'recharge',
      ['rechargeType', 'rechargeMethodByValue', 'rechargeStatus', 'nodeState', 'notifyState']),
  },
  methods: {
    loadData(t) {
      var chartDom = document.getElementById('main');
      var myChart = echarts.init(chartDom);
      if (t === 'groupId') {
        myChart.clear()
      }
      api.order.dashboardChart(this.queryForm).then(res => {
        let {legendData, series, xaxisData} = res.data
        console.log(series.map(e => e.data.map(item => +item)))
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            data: legendData
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xaxisData
          },
          yAxis: {
            type: 'value'
          },
          series: series.map(e => {
            e.data = e.data.map(item => +item)
            return e
          })
        }
        option && myChart.setOption(option);
      })
    }
  },
  mounted() {
    this.loadData()

  }
}
</script>

<template>
  <div>
    <Row :gutter="21">
      <Col>
        <Select v-model="queryForm.groupId" style="width:200px" @on-change="loadData('groupId')">
          <Option value="supplier_name">供应商</Option>
          <Option value="commodity_name">卡券</Option>
        </Select>
      </Col>
      <Col>
        <InputNumber v-model="queryForm.day" @on-change="loadData"></InputNumber>
      </Col>
      <Col>
        <Select v-model="queryForm.nodeState" clearable style="width: 200px" @on-change="loadData('groupId')">
          <Option v-for="item in nodeState" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </Col>
    </Row>
    <div id="main" style="height: 1000px; width: 100%">

    </div>
  </div>
</template>

<style scoped lang="less">

</style>
